/*
import { ProposalDto } from '../../types/spool-local';
import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';
import { EmissionSpoolDto } from '../../../context/emissionSpools/emissionSpoolsType';
import { getProposalScores } from '../../../helpers/sdkHelper';
import { sleep } from '../../../web3/utils';
import useLatestProposal from './useLatestProposal';
import useProposalVotingResult from './useProposalVotingResult';
*/

import { EmissionSpoolDto } from '../../../context/emissionSpools/emissionSpoolsType';

/*
const useEmissionSpools = () => {
    const { interfaceSDK } = useContext(appContext);

    const { chainId } = useWeb3React();

    const { latestProposal } = useLatestProposal();

    const { proposalVotingResult } = useProposalVotingResult();

    const { data, error, mutate } = useSWR(
        interfaceSDK && latestProposal && proposalVotingResult
            ? ['emissionSpools', latestProposal, proposalVotingResult, chainId]
            : null,
        async (_, latestProposal: ProposalDto, proposalVotingResult) => {
            const spoolDtos = await interfaceSDK!.get.getProposalSpoolDetails(
                latestProposal.id
            );

            const proposalScores = await getProposalScores(latestProposal.id);

            // const relativeProposalVotingResult: { [key: string]: number } =
            //     Object.entries(proposalVotingResult.relative).reduce(
            //         (accumulator, [key, value]) => {
            //             return {
            //                 ...accumulator,
            //                 [key.toLowerCase()]: value,
            //             };
            //         },
            //         {}
            //     );

            // const absoluteProposalVotingResult: { [key: string]: number } =
            //     Object.entries(proposalVotingResult.absolute).reduce(
            //         (accumulator, [key, value]) => {
            //             return {
            //                 ...accumulator,
            //                 [key.toLowerCase()]: value,
            //             };
            //         },
            //         {}
            //     );

            return Promise.all(
                Object.entries(spoolDtos).map(([spoolAddress, spoolDetails]) => {
                    return {
                        ...spoolDetails,
                        address: spoolAddress,
                        allocWeight:
                            (proposalScores.relativeScores as any)?.[
                                spoolAddress.toLowerCase()
                            ] ?? 0,
                        allocAmount:
                            (proposalScores.absoluteScores as any)?.[
                                spoolAddress.toLowerCase()
                            ] ?? 0,
                    } as EmissionSpoolDto;
                })
            );
        }
    );

    const update = async (previousValue?: number) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            const emissionSpoolsAllocWeight = currentValue?.reduce(
                (accumulatedAlloc, emissionSpool) =>
                    accumulatedAlloc + emissionSpool.allocAmount,
                0
            );

            if (emissionSpoolsAllocWeight !== previousValue) {
                break;
            }
            retries++;
            await sleep(3000);
        } while (retries < 5);
    };

    return {
        emissionSpools: data,
        isLoading: !error && !data,
        error,
        updateEmissionSpools: update,
    };
};
*/

const useMockEmissionSpools = () => {
    const mockEmissionSpools: EmissionSpoolDto[] = [
        {
            address: '0x1111111111111111111111111111111111111111',
            allocWeight: 500,
            allocAmount: 1000,
            spoolName: 'Spool A',
            underlying: { address: '0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', symbol: 'USDC', decimals: 6 } as any,
            tvr: '1000000',
            apy: '12.5',
            futureApy: '13.0',
            depositedAmount: '500000',
            alloc: 500,
        },
        {
            address: '0x2222222222222222222222222222222222222222',
            allocWeight: 300,
            allocAmount: 600,
            spoolName: 'Spool B',
            underlying: { address: '0xbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb', symbol: 'USDT', decimals: 6 } as any,
            tvr: '800000',
            apy: '8.3',
            futureApy: '9.0',
            depositedAmount: '300000',
            alloc: 300,
        },
        {
            address: '0x3333333333333333333333333333333333333333',
            allocWeight: 200,
            allocAmount: 400,
            spoolName: 'Spool C',
            underlying: { address: '0xcccccccccccccccccccccccccccccccccccccccc', symbol: 'DAI', decimals: 18 } as any,
            tvr: '500000',
            apy: '15.7',
            futureApy: '16.0',
            depositedAmount: '200000',
            alloc: 200,
        },
    ];

    const updateEmissionSpools = async (previousValue?: number) => {
        console.log('Mock updateEmissionSpools called with:', previousValue);
    };

    return {
        emissionSpools: mockEmissionSpools,
        isLoading: false,
        error: null,
        updateEmissionSpools,
    };
};

export default useMockEmissionSpools;
